import React from 'react';
import {
  Chart,
  Series,
  CommonSeriesSettings,
  Legend,
  Export,
  Tooltip,
  Label,
} from 'devextreme-react/chart';

function customizeTooltip(arg) {
  const { data } = arg.point;

  const percentageKey = {
    'Improvement': 'upgradedPercentage',
    'No significant change': 'noChangePercentage',
    'Quality deterioration': 'downGradedPercentage'
  }[arg.seriesName];

  const percentage = data?.[percentageKey] ?? 0;

  return {
    text: `${arg.seriesName}: ${arg.value}`
  };
}


function StackedBar({ data }) {
  return (
    <React.Fragment>
      <Chart
        id="chart"
        palette={["#6CE9A6", "#FEC84B", "#F97066"]}
        dataSource={data || []}
        rotated={true}
        size={{ height: 160 }}
        legend={{ visible: false }}   // 👈 this is important

      >
        <CommonSeriesSettings argumentField="state" type="stackedbar" />

        <Series valueField="upgraded" name="Upgrade">
          <Label
            visible={true}
            font={{ weight: 700, color: '#000' }}
            customizeText={(arg) =>
              `Upgrade: ${arg.value} (${arg.point.data.upgradedPercentage}%)`
            }
          />
        </Series>

        <Series valueField="noChange" name="No Change">
          <Label
            visible={true}
            font={{ weight: 700, color: '#000' }}
            customizeText={(arg) =>
              `No Change: ${arg.value} (${arg.point.data.noChangePercentage}%)`
            }
          />
        </Series>

        <Series valueField="downGraded" name="Downgrade">
          <Label
            visible={true}
            font={{ weight: 700, color: '#000' }}
            customizeText={(arg) =>
              `Downgrade: ${arg.value} (${arg.point.data.downGradedPercentage}%)`
            }
          />
        </Series>


        {/* 3 */}

        <Export
          enabled={true}
          formats={['PNG', 'PDF', 'SVG']}
          fileName="fillet-chart"
        />
        <Tooltip enabled={true} location="edge" customizeTooltip={customizeTooltip} />
      </Chart>
    </React.Fragment>
  );
}

export default StackedBar;
